import { Type } from 'typebox';
import { FamilyMedia } from '@tadpoles/common';
export const GalleryListRequest = Type.Object({
    since: Type.Optional(Type.Number()),
    numMedia: Type.Optional(Type.Number()),
    cursor: Type.Optional(Type.String())
});
export const GalleryListPayload = Type.Object({
    familyMedia: Type.Array(FamilyMedia),
    cursor: Type.Optional(Type.String())
});
export class HttpGalleryResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async list(request = {}, options) {
        return await this.#httpClient.post({
            path: '/media/parent/query',
            body: request,
            bodySchema: GalleryListRequest,
            payloadSchema: GalleryListPayload,
            signal: options?.signal
        });
    }
}
